export const iconFontAwesomeFilmVideoFileVideo = (
	<i className="fa-solid fa-file-video"></i>
);
